import {TYPE_SOCIAL_MEDIA_LEAD} from 'constants/leads';

export const leadFormInitialValues = {
	buildingNotFound: false,
	clientNotFound: false,
	building: null,
	address: '',
	zip: '',
	city: '',
	clientId: '',
	clientFirstName: '',
	clientLastName: '',
	phone: '',
	products: [],
	salesmanager: '',
	comment: '',
	type: TYPE_SOCIAL_MEDIA_LEAD,
};

export const salesmanagersQuery = {
	_limit: 999,
	type: 'salesmanager',
	include: 'allTeams,organizations',
};
